<template>
    <div>
        <span @click="selectScanByCompanyId()">
            <Button type="primary" @click="modal = true" v-hasPermission="['permissionsConfigurationManagement:accounts:search_new_resources']">{{ $t('permission_configuration_management.account.searchNewResource') }}</Button>
        </span>
        <!-- 操作日志详情 -->
        <configuration-management-operation-log v-if="isShowOperationLog" ref="configurationManagementOperationLog"></configuration-management-operation-log>
        <Modal v-model="modal" :title="$t('permission_configuration_management.account.searchNewResource')" :loading="loading" :mask-closable="false" :styles="{top:'100px'}">
            <Form ref="resourceScanForm" :model="resourceScanForm" :label-width="100" :rules="ruleValidate">
                <!-- 扫描资源 -->
                <FormItem :label="$t('permission_configuration_management.account.scanResource')" prop="scanResources">
                    <Select v-model="resourceScanForm.scanResources" style="width:300px;">
                        <Option :value="item.scanResources" v-for="(item,index) in scanResourcesList" v-bind:key="index">{{item.scanResourcesName}}</Option>
                    </Select>
                </FormItem>
                <!-- 选择公司 -->
                <div v-show="isShowCompany">
                    <FormItem :label="$t('permission_configuration_management.account.company')" prop="companyId">
                        <Select v-model="companyId" filterable placeholder=" " :transfer="true" style="width:300px;" @on-change="getAccount()">
                            <Option value=" " selected>{{$t('alarms.common.all')}}</Option>
                            <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </div>
                <!-- 选择账号 -->
                <FormItem :label="$t('permission_configuration_management.account.account')" prop="accountIds">
                    <Select v-model="accountIds" filterable multiple :max-tag-count="1" placeholder=" "  :transfer="true" style="width:300px;" @on-change="changeAccount()">
                        <Checkbox v-model="singleAccount" @on-change="selectAllAccount" style="display: block;text-align:right;">{{ $t('configuration_management.customized_alarm_config.checkAll') }}</Checkbox>
                        <Option :value="item.id" v-for="item in accountList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 监控模块 -->
                <FormItem :label="$t('configuration_management.common.monitorModule')" prop="monitorModules">
                    <Select v-model="resourceScanForm.monitorModules" multiple style="width:300px;" :transfer="true" placeholder=" ">
                        <Option :value="item.id" v-for="item in monitorModuleList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 标签扫描间隔 -->
                <FormItem :label="$t('permission_configuration_management.account.labelScanInterval')" prop="scanInterval">
                    <InputNumber :min="1" :max="23" v-model="resourceScanForm.scanInterval" style="width:300px;margin-right: 8px;"></InputNumber> {{ $t('configuration_management.schedules.hour') }}
                </FormItem>

                <!-- 联系方式 -->
                <FormItem :label="$t('permission_configuration_management.account.contactType')" prop="contactType">
                    <RadioGroup v-model="resourceScanForm.contactType" @on-change="changeContactType(resourceScanForm.contactType)">
                        <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                    </RadioGroup>
                </FormItem>

                <!-- 联系人组 -->
                <FormItem :label="$t('permission_configuration_management.account.contactGroup')" prop="contactGroupId" v-if="resourceScanForm.contactType==1">
                    <Select v-model="resourceScanForm.contactGroupId" style="width:300px;">
                        <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 自定义告警是否覆盖默认告警 -->
                <FormItem prop="isCoverDefault">
                    <Checkbox :key="resourceScanForm.isCoverDefault" v-model="resourceScanForm.isCoverDefault">
                        <span>{{ $t('permission_configuration_management.account.isCoverDefault') }}</span>
                    </Checkbox>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="success" @click="scanResource()" style="float:left;">{{ $t('permission_configuration_management.account.immediatelyScan') }}</Button>
                <Button type="success" @click="operationLog()">{{ $t('permission_configuration_management.account.operationLog') }}</Button>
                <Button type="primary" @click="tagScanSubmit('resourceScanForm')">{{ $t('permission_configuration_management.account.update') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    var resourceScanVue = {}
    export default {
        components:{
          ConfigurationManagementOperationLog
        },
        name: 'TagScan',
        data () {
            return {
                isShowOperationLog: false,
                isShowCompany : false,
                companyId: '',
                company: getCookie(global.companyId),
                companyList: [],
                accountList: [],
                accountIds: [],
                singleAccount: false,
                contactTypeList: [{
                    label: this.$t('permission_configuration_management.account.contact'),
                    value: 'contact',
                    type: 0
                },
                {
                    label: this.$t('permission_configuration_management.account.contactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                // 联系人组
                contactGroupIdList:[],
                resourceScanForm: {
                    scanResources: 0,
                    scanInterval: 6,
                    monitorModules:[0],
                    isCoverDefault: true,
                    contactType: 0,
                    contactGroupId:''
                },
                scanResourcesList: [{
                    scanResources:0,
                    scanResourcesName: this.$t('permission_configuration_management.account.disable')
                },{
                    scanResources:1,
                    scanResourcesName: this.$t('permission_configuration_management.account.enable')
                }],
                // 监控模块
                monitorModuleList:[],
                dataList:[],
                modal: false,
                loading: true,
                ruleValidate: {
                    scanResources: [
                        { required: true, message: '请选择扫描资源', trigger: 'change',type: 'number'}
                    ],
                    scanInterval: [
                        { required: true, message: '请输入标签扫描间隔', trigger: 'blur',type: 'number'}
                    ],
                    monitorModules: [
                        { required: true, message: '请选择监控模块', trigger: 'change',type:'array' }
                    ]
                    ,contactType: [
                        {required: true, message: '请选择联系方式', trigger: 'change', type: 'number'}
                    ],
                    contactGroupId: [
                        {required: true, message: '请选择联系人组', trigger: 'change', type: 'number'}
                    ]
                }
            }
        },
        beforeCreate: function () {
            resourceScanVue = this
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
                this.isShowCompany = true;
            }
            this.getAccount();
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
            },
            // 查询账号
            getAccount:function() {
                // 清空数组
                this.accountList = [];
                // 清空选中的数据
                this.accountIds = [];
                // 清空复选框
                this.singleAccount= false;
                // 账号下拉框
                this.$api.account.queryAccountsByCompanyId("companyId",(this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId)
                    .then(res => {
                        if (res.data != null && res.data.length > 0) {
                            this.accountList=res.data;
                            // 默认全选账户
                            for (var i = 0; i < this.accountList.length; i++){
                                this.accountIds.push(this.accountList[i].id);
                            }
                            this.singleAccount = true;
                        }
                })

                // 加载其他
                this.selectScanByCompanyId();
            },
            // 全选账号
            selectAllAccount(){
                this.accountIds = [];
                if (this.singleAccount) {
                    this.accountList.map((item) => {
                        this.accountIds.push(item.id)
                    })
                } else {
                    this.accountIds = [];
                }
            },
            // 账号改变事件
            changeAccount(){
                if (this.accountIds.length < this.accountList.length) {
                    this.singleAccount = false;
                }
            },
            // 根据用户名获取扫描资源
            selectScanByCompanyId:function(){
                resourceScanVue.searchMonitorModule();
                resourceScanVue.$api.account.selectScanByCompanyId("companyId",(this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId)
                .then(res => {
                    // 扫描资源
                    this.dataList=res.data;
                    if (this.dataList.isScan==0) {
                        this.resourceScanForm.scanResources=0;
                    } else if(this.dataList.isScan==1){
                        this.resourceScanForm.scanResources=1;
                    }
                    // 资源类型
                    if (this.dataList.scanResourceType != null && this.dataList.scanResourceType != undefined) {
                        this.resourceScanForm.monitorModules = this.dataList.scanResourceType;
                    }
                    // 扫描已存在自定义告警的资源
                    if (this.dataList.isCoverDefault != null && this.dataList.isCoverDefault != undefined) {
                        this.resourceScanForm.isCoverDefault = this.dataList.isCoverDefault;
                    }
                    // 标签扫描间隔
                    if (this.dataList.scanInterval != null && this.dataList.scanInterval != undefined) {
                        this.resourceScanForm.scanInterval = this.dataList.scanInterval;
                    }
                    // 联系方式
                    if (this.dataList.contactType != null && this.dataList.contactType != undefined) {
                        this.resourceScanForm.contactType = res.data.contactType;
                    }
                    // 公司ID
                    if (this.dataList.companyId != null && this.dataList.companyId != undefined) {
                        this.companyId = res.data.companyId;
                        if (this.company == 1) {
                            this.isShowCompany = true;
                        }
                    }
                    // 账号ID
                    if (this.dataList.accountIds != null && this.dataList.accountIds != undefined && this.dataList.accountIds.length > 0) {
                        this.accountIds = [];
                        for (var i = 0; i < res.data.accountIds.length; i++){
                            this.accountIds.push(res.data.accountIds[i]);
                        }
                    }
                    if(this.resourceScanForm.contactType == 1){
                        // 联系人组
                        this.$api.contactGroup.listContactGroups()
                        .then(res => {
                            this.contactGroupIdList = res.data;
                        })
                        setTimeout(() => {
                            this.resourceScanForm.contactGroupId = res.data.defaultContactGroupId;
                        }, 100)
                    }
                })
            },
            // 查询监控模块
            searchMonitorModule: function(){
                this.$api.alertRule.searchMonitorModuleV2("userName",getCookie(global.cookieName))
                .then(res => {
                    this.monitorModuleList = res.data;
                })
            },

            // 立即扫描
            scanResource:function(){
                resourceScanVue.$api.account.scanResource({
                    "companyId": this.companyId
                })
                .then(res => {
                    setTimeout(() => {
                        this.$Message.success('扫描成功');
                    },1000);
                })
            },
            // 切换联系方式
            changeContactType:function(){
                if(this.resourceScanForm.contactType===1){
                    this.$api.contactGroup.listContactGroups()
                    .then(res => {
                        this.contactGroupIdList = res.data;
                    })
                }
            },
            tagScanSubmit: function(name){
                resourceScanVue.$refs[name].validate(valid => {
                    if(valid){
                        // 更新扫描配置
                        var scanData={
                            "companyId": (this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId,
                            "accountIds": this.accountIds,
                            "isScan": this.resourceScanForm.scanResources,
                            "scanInterval": this.resourceScanForm.scanInterval,
                            "isCoverDefault": this.resourceScanForm.isCoverDefault,
                            "scanResourceType": this.resourceScanForm.monitorModules,
                            "contactType":this.resourceScanForm.contactType
                        };

                        // 如果联系方式是联系人组 传联系人组
                        if(this.resourceScanForm.contactType == 1){
                            scanData.defaultContactGroupId = this.resourceScanForm.contactGroupId;
                        }

                        this.$api.account.updateScan(scanData)
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                this.$refs[name].resetFields();
                                this.companyId = '';
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success('更新成功');
                                this.modal = false;
                            },1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error('更新失败');
                    }
                });
            },
            // 操作日志
            operationLog: function () {
                this.isShowOperationLog = true;
                this.$nextTick(function () {
                    this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(this.companyId,17);
                })
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account/ResourceScan.vue